import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from "../BaseApi";

const employeeProviderSlice = createSlice({
    name: 'employeeProvider',
    initialState: {
        createEmployeeProviderOrder: [],
        updateEmployeeProviderOrder: [],
        detailEmployeeProviderOrder: {},
        getEmployeeProviderLists: [],
        incomingProviders: [],
        recordsProviders: [],
        createEmployeeProviderPre: [],
        detailEmployeeProviderEmployee: {},
        detailEmployeeProviderOrderFiles: null,
        detailEmployeeProviderVehicle: {},
        approveExternalDocument: null,
        getCurrentUserDocument: [],
        getUserDocumentsEmployee: {},
        createToExternalEmployee: {},
        createEmployeeOrder: {},
        getEmployeeSupplierByItId: {},
        createSupplierOrder: null,
    },
    reducers: {
        ClearGetEmployeeProviderByPhoneNumber: (state, action) => {
            state.getEmployeeProviderByPhoneNumber = {};
        },

        ClearGetEmployeeProviderByEmail: (state, action) => {
            state.getEmployeeProviderByEmail = {};
        },

        ClearGetEmployeeSupplierByItId: (state, action) => {
            state.getEmployeeSupplierByItId = {};
        },
    },
    extraReducers: {
        'employeeProvider/getEmployeeProviderLists/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeProviderLists = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },

        'employeeProvider/getGnderListProvider/fulfilled': (state, action) => {
            state.getGnderListProvider = ResponseApi(action.payload);
        },
        'employeeProvider/EmployeeProviderPreUser/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createEmployeeProviderPre = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getEmployeeProviderByEmail/fulfilled': (state, action) => {
            state.getEmployeeProviderByEmail = ResponseApi(action.payload);
        },

        'employeeProvider/approveExternalDocument/fulfilled': (state, action) => {
            state.approveExternalDocument = ResponseApi(action.payload);
        },
        'employeeProvider/getAllProviderDocument/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getCurrentUserDocument = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getUserDocumentsEmployee/fulfilled': (state, action) => {
            state.getUserDocumentsEmployee = ResponseApi(action.payload);
        },

        'employeeProvider/createToExternalEmployee/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createToExternalEmployee = data;
            }
        },
        'employeeProvider/getEmployeeSupplierByItId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeSupplierByItId = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(data.message);
            }
        },
    },
});

export const {
    ClearGetEmployeeProviderByPhoneNumber,
    ClearGetEmployeeProviderByEmail,
    ClearGetEmployeeSupplierByItId,
} = employeeProviderSlice.actions;

export default employeeProviderSlice.reducer;
